import { render, staticRenderFns } from "./SalesList_List.vue?vue&type=template&id=683a22f2&"
import script from "./SalesList_List.vue?vue&type=script&lang=js&"
export * from "./SalesList_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports